var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	1924: {
		fallback: function() { return __webpack_require__.e(368).then(function() { return function() { return __webpack_require__(3368); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",
	},
	865: {
		fallback: function() { return Promise.all([__webpack_require__.e(519), __webpack_require__.e(884), __webpack_require__.e(715), __webpack_require__.e(78)]).then(function() { return function() { return __webpack_require__(6715); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/router",
	},
	3224: {
		fallback: function() { return Promise.all([__webpack_require__.e(519), __webpack_require__.e(725)]).then(function() { return function() { return __webpack_require__(1106); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",
	},
	9914: {
		fallback: function() { return Promise.all([__webpack_require__.e(884), __webpack_require__.e(78), __webpack_require__.e(165)]).then(function() { return function() { return __webpack_require__(8133); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",
	},
	8006: {
		fallback: function() { return Promise.all([__webpack_require__.e(965), __webpack_require__.e(78)]).then(function() { return function() { return __webpack_require__(9965); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",
	},
	4178: {
		fallback: function() { return __webpack_require__.e(953).then(function() { return function() { return __webpack_require__(4953); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",
	},
	1995: {
		fallback: function() { return __webpack_require__.e(593).then(function() { return function() { return __webpack_require__(4848); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",
	},
	9434: {
		fallback: function() { return function() { return __webpack_require__(6540); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.2.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",
	},
	8712: {
		fallback: function() { return __webpack_require__.e(816).then(function() { return function() { return __webpack_require__(4435); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",
	},
	7733: {
		fallback: function() { return __webpack_require__.e(513).then(function() { return function() { return __webpack_require__(2513); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",
	},
	7849: {
		fallback: function() { return function() { return __webpack_require__(5852); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "11.11.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@emotion/cache",
	},
	1483: {
		fallback: function() { return function() { return __webpack_require__(196); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "11.10.8",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	9247: {
		fallback: function() { return __webpack_require__.e(593).then(function() { return function() { return __webpack_require__(5338); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",
	},
	7078: {
		fallback: function() { return function() { return __webpack_require__(961); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.2.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",
	},
	7266: {
		fallback: function() { return __webpack_require__.e(953).then(function() { return function() { return __webpack_require__(4953); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^14.2.23",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",
	},
	932: {
		fallback: function() { return __webpack_require__.e(368).then(function() { return function() { return __webpack_require__(3368); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^14.2.23",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",
	},
	7303: {
		fallback: function() { return function() { return __webpack_require__(5879); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "11.10.8",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@emotion/styled",
	},
	8088: {
		fallback: function() { return __webpack_require__.e(106).then(function() { return function() { return __webpack_require__(1106); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^14.2.23",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",
	},
	8698: {
		fallback: function() { return __webpack_require__.e(133).then(function() { return function() { return __webpack_require__(8133); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^14.2.23",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",
	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [1924,865,3224,9914,8006,4178,1995,9434,8712,7733,7849,1483,1995,9434,9247,7078,7849,1483,865,7266];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
__webpack_require__.consumesLoadingData.chunkMapping = {
	"78": [
		7078
	],
	"266": [
		7266
	],
	"527": [
		1924,
		865,
		3224,
		9914,
		8006,
		4178,
		1995,
		9434,
		8712,
		7733,
		7849,
		1483
	],
	"556": [
		932,
		7303,
		8088,
		8698
	],
	"636": [
		865
	],
	"792": [
		1995,
		9434,
		9247,
		7078,
		7849,
		1483
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}